import ApiClient from "shared/services/api/ApiClient";

// this works for both Axios and Spraypaint
// eslint-disable-next-line import/prefer-default-export
export const isAbortError = (error: unknown): boolean =>
  (ApiClient.isApiError(error) && ApiClient.isCancel(error)) ||
  (error instanceof DOMException && error.name === "AbortError") ||
  (error as { originalError?: { name: string } })?.originalError?.name ===
    "AbortError";
